var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconMedal = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17.066,
  height: 21.609,
  viewBox: "0 0 17.066 21.609",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "medal",
  d: "M14,16.04l.96-2.958-2.533-1.9H15.52l1.013-3.061.987,3.061h3.12l-2.533,1.9.933,2.958-2.507-1.827Zm-3.76,9.57V17.789a7.246,7.246,0,0,1-1.72-2.65A8.508,8.508,0,0,1,8,12.232a7.822,7.822,0,0,1,2.453-5.865A8.415,8.415,0,0,1,16.533,4a8.415,8.415,0,0,1,6.08,2.367,7.822,7.822,0,0,1,2.453,5.865,8.508,8.508,0,0,1-.52,2.907,7.246,7.246,0,0,1-1.72,2.65v7.821l-6.293-2.032Zm6.293-6.689a6.819,6.819,0,0,0,4.92-1.942,6.343,6.343,0,0,0,2.013-4.746,6.343,6.343,0,0,0-2.013-4.746,6.819,6.819,0,0,0-4.92-1.942,6.819,6.819,0,0,0-4.92,1.942A6.343,6.343,0,0,0,9.6,12.232a6.343,6.343,0,0,0,2.013,4.746A6.819,6.819,0,0,0,16.533,18.921ZM11.84,23.449l4.693-1.415,4.693,1.415v-4.4a7.349,7.349,0,0,1-2.293,1.08,8.778,8.778,0,0,1-4.8,0,7.349,7.349,0,0,1-2.293-1.08ZM16.533,21.236Z",
  transform: "translate(-8 -4)",
  fill: "#fff"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMedal, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_medal.4f1a67a3.svg";
export { ForwardRef as ReactComponent };